import { render, staticRenderFns } from "./BatchDetail.vue?vue&type=template&id=59cbb6e8&scoped=true&"
import script from "./BatchDetail.vue?vue&type=script&lang=js&"
export * from "./BatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./BatchDetail.vue?vue&type=style&index=0&id=59cbb6e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cbb6e8",
  null
  
)

export default component.exports